<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input
          v-model="query.keywords"
          clearable
          style="width:400px;"
          placeholder="请输入企业名称/企业id"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addFriends">新增</el-button>
      </div>
    </div>
    <el-table ref="multipleTable" v-loading="loading" :data="tableData" border>
      <el-table-column
        prop="detection_title"
        label="标题"
        align="center"
        width="350"
      />
      <el-table-column label="员工" align="center">
        <template slot-scope="scope">
          <el-tooltip
            effect="light"
            popper-class="custom-tooltip"
            placement="right"
          >
            <template #content>
              <div style="width: 350px">
                <el-tag
                  v-for="(item, index) in scope.row.employee_detail"
                  :key="index"
                  style="margin: 2px"
                  size="mini"
                >
                  {{ item.name }}({{ item.employee_no }})
                </el-tag>
              </div>
            </template>

            <!-- 显示前 2-3 个名字，后面加... -->
            <div class="ellipsis-cell">
              {{ formatShortEmployees(scope.row.employee_detail) }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        label="状态"
        align="center"
        width="160"
      >
        <template #default="{ row }">
          <el-switch
            v-model="row.detection_status"
            :active-value="1"
            :inactive-value="2"
            active-text="开启"
            inactive-text="关闭"
            active-color="#13ce66"
            inactive-color="#dcdfe6"
            :disabled="row._switchDisabled"
            @change="val => handleToggle(val, row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="created_at_text" label="创建时间" align="center" width="180" />
      <el-table-column prop="detection_time_text" label="监测时间" align="center" width="180" />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
        width="150"
      />
      <el-table-column label="操作" align="center">
        <template scope="scope">
          <el-button type="primary" size="mini" @click="editFriends(scope.row)">修改</el-button>
          <el-button type="danger" size="mini" @click="delFriend(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title=" id? '修改监测':'新增监测'"
      width="1000px"
      :visible.sync="dialogVisible"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标题" prop="detection_title">
          <el-input v-model="form.detection_title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="选择员工" prop="employee_nos">
          <el-button @click="getEmployee">点我选择</el-button>
        </el-form-item>
        <el-form-item>
          <div style="max-height: 400px;overflow-y: auto;border: 1px solid #ebeef5">
            <el-tag v-for="item,index in form.employee_nos" :key="index" style="margin: 2px">{{ item.name }}({{ item.employee_no }})</el-tag>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="success" style="margin:0px 10px;" @click="commitFriend">确定</el-button>
          <el-button type="info" @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
      <el-dialog
        :visible.sync="bandlabel_visible"
        append-to-body
      >
        <bandstaff ref="bandlabel" @bandarr="bandarr" />
      </el-dialog>

    </el-dialog>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import bandstaff from './components/bandstaff.vue'
import {
  addEmployeeFriend, delEmployeeFriend,
  employeeFriendChange,
  getEmployeeFriendList,
  updEmployeeFriend
} from '@/api/officialaccount.js'

export default {
  name: 'YrGsFriends',
  components: { bandstaff, PaginationRight },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null
        // suite_id: null
      },
      bandlabel_visible: false,
      rules: {
        detection_title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        employee_nos: [
          {
            validator(rule, value, callback) {
              if (!value || value.length === 0) {
                callback(new Error('请选择员工'))
              } else {
                callback()
              }
            },
            trigger: 'change' // change 触发没问题，手动校验时也会触发
          }
        ]
      },
      form: {
        detection_title: '',
        employee_nos: []
      },
      id: undefined
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      this.loading = true
      const data = await getEmployeeFriendList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      // console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.list()
    },
    getEmployee() {
      this.bandlabel_visible = true
      this.$nextTick(() => {
        this.$refs.bandlabel.sendr(undefined, this.form.employee_nos)
      })
    },
    handleToggle(newVal, row) {
      console.log(newVal, row)
      // 立即更新UI
      row.status = newVal ? 2 : 1

      // 禁止再次点击
      this.$set(row, '_switchDisabled', true)

      // 模拟接口或刷新机制（你可能1秒后重新拉表格数据）
      setTimeout(() => {
        row._switchDisabled = false // 恢复点击
        // 如果你有刷新列表，这一步也可以省略
      }, 1000)
      employeeFriendChange({ id: row.id, detection_status: newVal }).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    },
    bandarr(val) {
      this.form.employee_nos = val
      this.bandlabel_visible = false
    },
    commitFriend() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 通过验证，提交处理逻辑
          var employee_data = {}
          employee_data.employee_nos = this.form.employee_nos.map(item => { return item.employee_no })
          employee_data.detection_title = this.form.detection_title
          console.log(employee_data, '111')
          console.log('验证通过:', this.form)
          if (this.id) {
            updEmployeeFriend({ ...employee_data, id: this.id }).then((res) => {
              console.log(res)
              if (res.code === 200) {
                this.$message.success('操作成功')
                this.list()
                this.dialogVisible = false
              }
            })
          } else {
            addEmployeeFriend(employee_data).then((res) => {
              console.log(res)
              if (res.code === 200) {
                this.$message.success('操作成功')
                this.list()
                this.dialogVisible = false
              }
            })
          }
        } else {
          console.log('验证失败')
        }
      })
    },
    editFriends(val) {
      console.log(val)
      this.id = val.id
      this.form.detection_title = val.detection_title
      this.form.employee_nos = val.employee_detail
      this.dialogVisible = true
    },
    delFriend(val) {
      console.log(val)
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        delEmployeeFriend({ id: val.id }).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.list()
          }
        })
      })
    },
    addFriends() {
      this.id = undefined
      this.dialogVisible = true
    },
    formatShortEmployees(list) {
      if (!list || list.length === 0) return ''
      const names = list.slice(0, 3).map(e => e.name) // 前3个名字
      return names.join(', ') + (list.length > 3 ? '...' : '')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.ellipsis-cell {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
